import { Descriptions, DescriptionsProps, Card } from 'antd'
import { useEffect, useState } from 'react'

export default function Overview({ admin }: any) {
    const [isMobile, setIsMobile] = useState(false)

    // Handle responsive behavior
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768)
        }

        // Check initial window size
        handleResize()

        // Add event listener
        window.addEventListener('resize', handleResize)

        // Cleanup
        return () => window.removeEventListener('resize', handleResize)
    }, [])

    const items: DescriptionsProps['items'] = [
        {
            key: 'full_name',
            label: 'Họ tên',
            children: admin?.full_name,
            span: isMobile ? 3 : 2,
        },
        {
            key: 'username',
            label: 'Tên tài khoản',
            children: admin?.username,
            span: isMobile ? 3 : 1,
        },
        {
            key: 'email',
            label: 'Email',
            children: admin?.email,
            span: isMobile ? 3 : 1,
        },
        {
            key: 'country',
            label: 'Quốc gia',
            children: admin?.country,
            span: isMobile ? 3 : 1,
        },
        {
            key: 'address',
            label: 'Địa chỉ',
            children: admin?.address,
            span: isMobile ? 3 : 1,
        },
    ].filter(item => {
        // Filter out items with empty, null, undefined, or whitespace-only values
        const value = item.children;
        return value !== null &&
            value !== undefined &&
            value !== '' &&
            (typeof value === 'string' ? value.trim() !== '' : true);
    })

    return (
        <div style={{
            padding: isMobile ? '8px' : '16px',
            margin: isMobile ? '0' : 'auto'
        }}>
            <Card
                style={{
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                    borderRadius: '12px',
                    border: '1px solid rgba(0, 0, 0, 0.06)',
                    background: 'linear-gradient(135deg, #ffffff 0%, #fafafa 100%)'
                }}
                bodyStyle={{
                    padding: isMobile ? '16px' : '24px'
                }}
            >
                <div style={{
                    marginBottom: isMobile ? '16px' : '20px',
                    textAlign: isMobile ? 'center' : 'left'
                }}>
                    <span style={{
                        fontWeight: 400,
                        fontSize: isMobile ? '16px' : '18px',
                        color: '#1f2937'
                    }}>
                        Nhóm quản trị: <b style={{
                            color: '#fa5d67',
                            fontWeight: 600
                        }}>{admin?.role?.name}</b>
                    </span>
                </div>

                <Descriptions
                    items={items}
                    column={isMobile ? 1 : 2}
                    size={isMobile ? 'small' : 'default'}
                    layout={isMobile ? 'vertical' : 'horizontal'}
                    labelStyle={{
                        fontWeight: 600,
                        color: '#374151',
                        fontSize: isMobile ? '14px' : '15px',
                        minWidth: isMobile ? 'auto' : '120px',
                        marginBottom: isMobile ? '4px' : '0'
                    }}
                    contentStyle={{
                        color: '#111827',
                        fontSize: isMobile ? '14px' : '15px',
                        fontWeight: 500,
                        wordBreak: 'break-word'
                    }}
                    style={{
                        background: 'transparent'
                    }}
                />
            </Card>
        </div>
    )
}
